import styled from '@emotion/styled';
import { SvgIcon } from '@mui/material';
import { Link } from 'react-router-dom';

type Props = {
  selected: boolean;
  icon: string;
  path: string;
  title: string;
};

export default function SideBarItem(props: Props) {
  return (
    <ItemRoot title={props.title} selected={props.selected} to={props.path}>
      <SvgIcon fontSize="medium">
        <path d={props.icon} />
      </SvgIcon>
      <span className="sidebar-item-title">{props.title}</span>
    </ItemRoot>
  );
}

const ItemRoot = styled(Link)<{ selected: boolean }>`
  display: flex;
  /* justify-content: center; */
  align-items: center;
  /* width: ${({ theme }) => theme.spacing(5)}; */
  height: ${({ theme }) => theme.spacing(5)};
  color: ${({ selected, theme }) =>
    selected ? theme.palette.info.main : theme.palette.text.secondary};
  text-decoration: none;
  font-weight: 500;
  padding: 0 8px;

  background-color: ${({ selected, theme }) =>
    selected ? theme.palette.action.selected : undefined};

  :hover {
    color: ${({ theme }) => theme.palette.primary.main};
    background-color: ${({ theme }) => theme.palette.action.hover};
  }

  .sidebar-item-title {
    margin-left: 4px;
  }
`;
